import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './ServiceTypeEditScreen';
import ServiceTypeEdit from './ServiceTypeEditScreen';
import { StoreState } from 'src/store/reducers';
import { getServiceType } from 'src/store/actions/service-type-actions';
import { QueryParams } from '../../../../../../types/grid';
import { getProviders, getProvidersSmall } from 'src/store/actions/provider-actions';
import { selectTitleProviders } from '../../../../../../store/selectors/providers-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        serviceType: state.serviceTypes.current,
        inProgress: state.serviceTypes.inProgress,
        providers: selectTitleProviders(state),
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        getData: (id) => dispatch(getServiceType(id)),
    };
}

const ServiceTypeEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ServiceTypeEdit);

export default ServiceTypeEditScreen;
